// Explorer Base URL
export const EXPLORER_BASE_URL = 'https://suiscan.xyz';
// LST Info Object ID - contains protocol configuration and state
export const STSUI_LST_INFO = '0x1adb343ab351458e151bc392fbf1558b3332467f23bda45ae67cd355a57fd5f5';
// stSUI Coin Type - full type signature for the stSUI token
export const STSUI_COIN_TYPE = '0xd1b72982e40348d069bb1ff701e634c117bb5f741f44dff91e472d3b01461e55::stsui::STSUI';
// SUI Coin Type - short form for wallet balances and transactions
export const SUI_COIN_TYPE = '0x2::sui::SUI';
// SUI Coin Type - padded form for price lookups from coinInfoData
export const SUI_COIN_TYPE_PADDED = '0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI';
// LST Parameters for SDK initialization
export const LST_PARAMS = {
    lstInfo: STSUI_LST_INFO,
    lstCointype: STSUI_COIN_TYPE,
};
// Decimal constants
export const SUI_DECIMALS = 9;
export const STSUI_DECIMALS = 9;
// Transaction constants
export const MIN_SUI_BALANCE = 0.5;
export const calculateReceiveAmount = (displayAmount, exchangeRate, action, unstakingFee) => {
    if (!displayAmount || displayAmount === '0')
        return '0';
    const amount = Number(displayAmount);
    const rate = exchangeRate;
    if (isNaN(amount) || isNaN(rate) || rate === 0)
        return '0';
    if (action === 'Stake') {
        return (amount / rate).toFixed(6);
    }
    else {
        const fee = Number(unstakingFee || 0);
        return (amount * rate * (1 - fee / 100)).toFixed(6);
    }
};
